// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-m_fr","advertDetailContacts__header":"c-m_fs"};